import GeneratorPage from './GeneratorPage/index';

export default GeneratorPage; 